import React, { MutableRefObject, ReactElement, useMemo } from "react"
import ClassNames from "classnames"
import { find } from "lodash"
import { BaseSelect } from "components/atoms/input/select"
import { Tab } from "components/atoms/btn/tab"
import { checkIsSp } from "utils/util"

type Props = {
  id?: string
  className?: string
  title: string | React.ReactNode
  filter?: React.FC | React.ReactNode
  children: React.FC | React.ReactNode
  delete?: Function
  refresh?: Function
  refElm?: MutableRefObject<HTMLDivElement>
  nonePanelHeader?: boolean
}

export const Panel: React.FC<Props> = props => {
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  return (
    <div
      ref={props.refElm}
      className={ClassNames("panel", props.className)}
      id={props.id}
    >
      {!props.nonePanelHeader && (
        <div className={ClassNames("panel-header")}>
          {props.title && (
            <div className="panel-header-title">
              {typeof props.title === "function" ? props.title() : props.title}
            </div>
          )}
          {props.filter}
          <div className="panel-header-icons">
            {typeof props.refresh === "function" && !isPhone ? (
              <i
                className="material-icons"
                onClick={() => props.refresh()}
                title={"更新"}
              >
                autorenew
              </i>
            ) : null}
            {typeof props.delete === "function" ? (
              <i className="material-icons" onClick={() => props.delete()}>
                clear
              </i>
            ) : null}
          </div>
        </div>
      )}
      <div className="panel-body">{props.children}</div>
    </div>
  )
}

type MenuPanelProps = {
  className?: string
  menu: Array<{
    id: number | string
    name: string
    component: React.FC<any>
    componentProps?: object
  }>
  active: number | string
  changeMenu: Function
  refresh?: Function
  comboBox?: boolean
  addFilter?: ReactElement
}

export const MenuPanel: React.FC<MenuPanelProps> = props => {
  const Contents = find(props.menu, { id: props.active })
  return (
    <Panel
      title=""
      // refresh={() => props.refresh()}
      className={props.className}
      filter={
        props.comboBox ? (
          <>
            <BaseSelect
              option={props.menu}
              value={props.active}
              onChange={(id: string) => {
                if (id === props.active) return
                props.changeMenu(id)
              }}
            />
            {props.addFilter && props.addFilter}
          </>
        ) : (
          <>
            <div className="panel-tab-container">
              <Tab
                className="foot-border-tabs nav-tabs"
                list={props.menu}
                active={props.active}
                onChange={props.changeMenu}
              />
            </div>
            {props.addFilter && props.addFilter}
          </>
        )
      }
    >
      {React.createElement(Contents.component, Contents.componentProps)}
    </Panel>
  )
}
